import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React from 'react';
import styled from 'styled-components';
import { getDisplayPrice } from '@finect/front-utils/getDisplayPrice';
import { Flex } from '@finect/tabular-core/Flex';
import { LineChart } from '../LineChart';
import { Product, Type } from './partials';
var Graph = styled.div.withConfig({
  displayName: "SecurityCard__Graph",
  componentId: "sc-caeft-0"
})(["display:flex;position:relative;flex-direction:column;flex-shrink:0;justify-content:center;width:120px;padding:0 15px 0 0;border-right:1px solid ", ";margin-right:15px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderColor;
}, function (_ref2) {
  var theme = _ref2.theme,
    bull = _ref2.bull;
  return bull ? theme.colors.positive : theme.colors.negative;
});
var GraphData = styled.div.withConfig({
  displayName: "SecurityCard__GraphData",
  componentId: "sc-caeft-1"
})(["display:flex;align-items:center;flex-wrap:wrap;justify-content:", ";font-size:12px;font-weight:", ";line-height:18px;&:not(:only-child){padding-top:6px;}span{flex:1;white-space:nowrap;color:", ";text-align:", ";}"], function (_ref3) {
  var nodata = _ref3.nodata;
  return nodata ? 'center' : 'space-between';
}, function (_ref4) {
  var nodata = _ref4.nodata;
  return nodata ? 400 : 600;
}, function (_ref5) {
  var theme = _ref5.theme,
    nodata = _ref5.nodata;
  return nodata ? theme.colors.fontLL : theme.colors.font;
}, function (_ref6) {
  var nodata = _ref6.nodata;
  return nodata ? 'center' : 'right';
});
var LegendVariation = styled.div.withConfig({
  displayName: "SecurityCard__LegendVariation",
  componentId: "sc-caeft-2"
})(["color:", ";"], function (_ref7) {
  var theme = _ref7.theme,
    bull = _ref7.bull;
  return bull ? theme.colors.positive : theme.colors.negative;
});
var ProductData = styled.div.withConfig({
  displayName: "SecurityCard__ProductData",
  componentId: "sc-caeft-3"
})(["", ";"], function (_ref8) {
  var extraMargin = _ref8.extraMargin;
  return extraMargin && 'margin-top: 12px;';
});
export var SecurityCard = function SecurityCard(_ref9) {
  var name = _ref9.name,
    category = _ref9.category,
    company = _ref9.company,
    link = _ref9.link,
    price = _ref9.price,
    variation = _ref9.variation,
    chart = _ref9.chart,
    withLink = _ref9.withLink;
  var baseURL = "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com');
  var url = link && (link.includes('finect') ? link : "".concat(baseURL).concat(link)) || '';
  var isCaps = name === name.toUpperCase();
  var productName = isCaps ? name.toLowerCase().replace(/\b\w/g, function (letter) {
    return letter.toUpperCase();
  }) : name;
  return React.createElement(Product, null, chart.length || price.value ? React.createElement(Graph, {
    bull: variation.percentage >= 0
  }, chart.length ? React.createElement(LineChart, {
    data: chart,
    strokeWidth: 2
  }) : null, React.createElement(GraphData, null, React.createElement(LegendVariation, {
    bull: variation.percentage >= 0
  }, variation.percentage > 0 ? '+' : '', variation.percentage.toLocaleString('es-ES', {
    maximumFractionDigits: 2
  }), "%"), React.createElement("span", null, price.value && getDisplayPrice(price.value, price.unit)))) : React.createElement(Graph, null, React.createElement(GraphData, {
    nodata: true
  }, React.createElement("span", null, "no disponible"))), React.createElement(Flex, {
    direction: "column",
    justify: "space-between"
  }, React.createElement(Type, null, category), React.createElement(ProductData, {
    extraMargin: Boolean(company)
  }, React.createElement("h4", null, withLink && url ? React.createElement("a", {
    href: url
  }, productName) : productName), company && React.createElement("small", null, company))));
};